import React from 'react';

const ViewBooking = () => {
  // This would eventually be fetched from a server
  const bookingDetails = {
    id: '12345',
    date: '2024-10-01',
    time: '18:00',
    location: 'Mumbai, India'
  };

  return (
    <div className="p-4 bg-white shadow-md rounded-lg">
      <h1 className="text-lg font-bold">Booking Details</h1>
      <p><strong>Date:</strong> {bookingDetails.date}</p>
      <p><strong>Time:</strong> {bookingDetails.time}</p>
      <p><strong>Location:</strong> {bookingDetails.location}</p>
    </div>
  );
};

export default ViewBooking;
